import { PortableText } from "@portabletext/react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useGetMyAccount } from "../../../../api/queries";
import useOpportunitiesQuery from "../../../../api/sanity/queries/getOpportunities";
import useSiteConfigAuth from "../../../../api/sanity/queries/getSiteConfigWithCode";
import urlFor from "../../../../api/sanity/sanityImageUrl";
import { hasAdminRights } from "../../../../auth/shared";
import H2 from "../../../../components/H2";
import HR from "../../../../components/Hr";
import LoadingSmall from "../../../../components/LoadingSmall";
import P from "../../../../components/P";
import RebrandPrimaryButton from "../../../../components/RebrandPrimaryButton";
import Spacer from "../../../../components/Spacer";
// import AppState from "../../../../store/appstate";
import useAppStore from "../../../../store/appStateZustand";

function Opportunities() {
  const history = useHistory();
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });
  const adminRights = hasAdminRights(myAccount?.data);
  const { t } = useTranslation("other");

  const { data: oppsData, isLoading, isSuccess } = useOpportunitiesQuery();
  const { data: siteConfig } = useSiteConfigAuth();
  // const allOpportunitiesAvailable = AppState.getRawState()?.allOpportunitiesAvailable;
  const allOpportunitiesAvailable = useAppStore(s => s.allOpportunitiesAvailable);
  let opps = [];
  if (allOpportunitiesAvailable) {
    opps = oppsData;
  }
  else {
    opps = oppsData?.opportunities_available;
  }

  const noOpps = siteConfig?.disable_opportunities;
  useEffect(() => {
    if (noOpps) {
      history.push("/");
    }
  }, [noOpps, history]);

  return (
    <>
      <div className="flex-1 order-last xl:w-full bg-sentric-rebrand-light-grey min-h-50 lg:min-h-screen-minus-header">
        <H2>{t("other:browse-opportunities-header")}</H2>
        <Spacer />
        <div className="w-full">
          {isLoading && <LoadingSmall />}
          {isSuccess && opps && opps.length > 0 ? (
            opps.map(opp => (
              <React.Fragment key={opp._id}>
                <div>
                  <P className="mb-2 font-semibold">{opp.name}</P>
                  <div className="flex flex-row justify-between w-full gap-2">
                    <div className="w-full xl:w-3/4 html-content">
                      <PortableText value={opp.description} />
                    </div>
                    <img
                      className="hidden object-cover rounded-lg xl:w-1/4 xl:flex h-72"
                      src={opp.imageUrl ? urlFor(opp.imageUrl).url() : null}
                      alt={opp.altText}
                    />
                  </div>
                  <Spacer thin />
                  <RebrandPrimaryButton
                    id="btnOpportunitiesApply"
                    onClick={
                      adminRights
                        ? () =>
                            opp.url
                              ? window.open(opp.url, "_blank")
                              : history.push(`/opportunities/apply/${opp._id}`)
                        : undefined
                    }
                    disabled={!adminRights}
                    arrow
                  >
                    {t("other:apply")}
                  </RebrandPrimaryButton>
                </div>
                <Spacer />
                <HR className="w-full lg:w-3/4" />
                <Spacer />
              </React.Fragment>
            ))
          ) : (
            <div>
              <p>{t("other:no-opportunities")}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default Opportunities;
